import { render, staticRenderFns } from "./IconEdit.vue?vue&type=template&id=2cbc28da&"
var script = {}
import style0 from "./IconEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cbc28da')) {
      api.createRecord('2cbc28da', component.options)
    } else {
      api.reload('2cbc28da', component.options)
    }
    module.hot.accept("./IconEdit.vue?vue&type=template&id=2cbc28da&", function () {
      api.rerender('2cbc28da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/IconEdit.vue"
export default component.exports